import { status } from '../../config.ts'

import { wait } from '@/__mocks__/util/async.ts'
import {
  alliesList,
  allyOverdueDevicesList,
  appleDevicesOverdueList,
  approvedPaymentsByEmployeesList,
  assignedMotorcyclesList,
  automaticPaymentsList,
  branchOfficesList,
  cashOutList,
  cashTopUpsList,
  clientGeolocation,
  data,
  marketplaceAllyPendingProductsList,
  movistarClubList,
  preassignedCreditSummaryList,
  overdueQuotasListList,
  quotesCollectionList,
  referralCodesList,
  salesByBranchList,
  userGeolocation,
  weppaPlusClientsList,
  zoneUList
} from './data.ts'
import dayjs from 'dayjs'

export default [
  {
    method: 'GET',
    path: '/reports/total-sales?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, alliesList]
    }
  },
  {
    method: 'GET',
    path: '/reports/sales-by-branch?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, salesByBranchList]
    }
  },
  {
    method: 'GET',
    path: '/reports/automatic-payments?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, automaticPaymentsList]
    }
  },
  {
    method: 'GET',
    path: '/report/apple_overdue?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, appleDevicesOverdueList]
    }
  },
  {
    method: 'GET',
    path: '/report/devices_overdue',
    reply: async () => {
      await wait()
      return [status.ok, overdueQuotasListList]
    }
  },
  {
    method: 'GET',
    path: '/report/ally_overdue?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, allyOverdueDevicesList]
    }
  },
  {
    method: 'GET',
    path: '/reports/approved-payments-by-employees?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, approvedPaymentsByEmployeesList]
    }
  },
  {
    method: 'GET',
    path: '/report/pending_delivery?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, marketplaceAllyPendingProductsList]
    }
  },
  {
    method: 'GET',
    path: '/report/branch/office/sales/export/to/csv?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, data]
    }
  },
  {
    method: 'GET',
    path: '/report/clients/by_referal_code?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, referralCodesList]
    }
  },
  {
    method: 'GET',
    path: '/report/branch-offices?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, branchOfficesList]
    }
  },
  {
    method: 'GET',
    path: '/report/clients/club_movistar?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, movistarClubList]
    }
  },
  {
    method: 'GET',
    path: '/report/preassigned-credit-summary?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, preassignedCreditSummaryList]
    }
  },
  {
    method: 'GET',
    path: '/report/weppa-plus?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, weppaPlusClientsList]
    }
  },
  {
    method: 'GET',
    path: '/report/clients/club_zone_u?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, zoneUList]
    }
  },
  {
    method: 'GET',
    path: `/report/cashout?createdAt=${dayjs().format('YYYY-MM-DD')}`,
    reply: async () => {
      await wait()
      return [status.ok, cashOutList]
    }
  },
  {
    method: 'POST',
    path: '/cashout-error/run-correction',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'GET',
    path: `/report/map/client?limit=1000`,
    reply: async () => {
      await wait()
      return [status.ok, clientGeolocation]
    }
  },
  {
    method: 'GET',
    path: `/report/map/user?limit=1000`,
    reply: async () => {
      await wait()
      return [status.ok, userGeolocation]
    }
  },
  {
    method: 'GET',
    path: '/report/assigned-motorcycles?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, assignedMotorcyclesList]
    }
  },
  {
    method: 'GET',
    path: '/report/daily-quote-payments?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, quotesCollectionList]
    }
  },
  {
    method: 'POST',
    path: '/recharges/services',
    reply: async () => {
      await wait()
      return [status.ok, cashTopUpsList]
    }
  }
]
